<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="26"
    viewBox="0 0 12.097 16.418"
  >
    <path
      class="svg-primary"
      d="M12.369,2.864H11.5V2H4.592v.864H3.728A1.728,1.728,0,0,0,2,4.592v12.1a1.728,1.728,0,0,0,1.728,1.728h8.641A1.728,1.728,0,0,0,14.1,16.69V4.592A1.728,1.728,0,0,0,12.369,2.864Zm-6.913,0h5.185v.864H5.456ZM13.233,16.69a.865.865,0,0,1-.864.864H3.728a.865.865,0,0,1-.864-.864V4.592a.865.865,0,0,1,.864-.864h.864v.864H11.5V3.728h.864a.865.865,0,0,1,.864.864ZM4.592,6.32H11.5v.864H4.592Zm0,2.592H11.5v.864H4.592Zm0,2.592H11.5v.864H4.592Zm0,2.592H8.049v.864H4.592Z"
      transform="translate(-2 -2)"
    />
  </svg>
</template>
<script>
export default {};
</script>
